module.exports = __webpack_public_path__ + "img/icon-stock-setting.efe14e5d.png";